import React, { useState, useContext, useEffect, useCallback } from "react";
import VideoComponent from "../components/VideoComponent";
import { AppContext } from "../contexts/AppContext";
import profile1 from "../img/profile-1.png";
import cameraIcon from "../img/camera-icon.png";
import undrawProfile from "../img/undraw_profile.svg";
import addFavourite from "../img/add-to-favorites.png";
import removeFavourite from "../img/remove.png";
import heart from "../img/heart-round.png";
import save from "../img/mark.png";
import useClickOutside from "../Hooks/UseClickOutside";
import axiosHttp from "../config/axios.interceptor";
import { useDispatch, useSelector } from "react-redux";
import { AuthContext } from "../contexts/AuthContext";
import { useNavigate, useParams } from "react-router-dom";
import {
  getFollowersFollowingsCount,
  getFollowersList,
  getFollowingsList,
  getuserInfo,
} from "../store/actions/userActions";
import {
  getCategoryList,
  getCountryList,
  getLanguageList,
  getStateList,
} from "../store/actions/utilActions";
import { truncateText } from "../../utils/application-helper";
import ImagePopup from "../components/ImagePopup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faInstagram,
  faLinkedin,
  faXTwitter,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import { errorResponseMessage, followerApiStatus } from "../shared/const.prop";
import Loader from "../components/Loader";
import ProfileView from "../components/ProfileView";
import { getActiveNotificationCount } from "../store/actions/notificationAction";
import { getActiveChatNotificationCount } from "../store/actions/chatNotificationAction";

const UserProfileView = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);
  const [isOpen, toggle, containerRef, setIsOpen] = useClickOutside(false);
  const [showImage, setShowImage] = useState("");
  const [isMyProfile, setIsMyProfile] = useState(false);
  const [userProfile, setUserProfile] = useState(null);
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user } = useContext(AuthContext);
  const { isLoggedIn, userData } = useSelector((state) => state.user);

  const userId = user?.userId || user?.data?.data?.userId;
  const userName = user?.userName || user?.data?.data?.userName;

  useEffect(() => {
    if (userName) {
      if (id == userName) {
        setIsMyProfile(true);
        setUserProfile(userData);
        setLoading(false);
      } else {
        setIsMyProfile(false);
        getProfile(id);
      }
    }
  }, [id, userId, userData]);

  useEffect(() => {}, []);

  useEffect(() => {
    if (userName && id == userName) {
      if (!isLoggedIn) {
        dispatch(getuserInfo());
      } else if (isLoggedIn && Object.keys(userData).length > 0) {
        dispatch(getCountryList());
        dispatch(getStateList(userData?.address?.countryId || ""));
        dispatch(getFollowersFollowingsCount());
        dispatch(getFollowersList());
        dispatch(getFollowingsList());
        dispatch(getLanguageList());
        dispatch(getActiveNotificationCount());
        dispatch(getActiveChatNotificationCount());
        dispatch(getCategoryList());
        fetchTestimonials();
      }
    }
  }, [id, isLoggedIn, userName]);

  useEffect(() => {
    if (userName && userName != id) {
      getProfile();
    }
  }, [location.pathname, appContext.openModal]);

  useEffect(() => {
    dispatch(getActiveNotificationCount());
    dispatch(getActiveChatNotificationCount());
  }, []);

  const getProfile = () => {
    setLoading(true);
    axiosHttp
      .get("profile/" + id)
      .then((apiResponse) => {
        if (apiResponse.status === 200) {
          setUserProfile(apiResponse?.data?.data ?? {});
          fetchTestimonials(apiResponse?.data?.data?.userId);
        } else {
          appContext.updateNotificationState({
            show: true,
            type: "error",
            message: "Error, please try after sometime.",
          });
          setLoading(false);
        }
      })
      .catch((error) => {
        if (error.response.status === 429) {
          appContext.updateNotificationState({
            show: true,
            message: errorResponseMessage(error),
            type: "error",
          });
          authContext.logout();
        }
        if (error.response.status === 400) {
          appContext.updateNotificationState({
            show: true,
            message: errorResponseMessage(error),
            type: "error",
          });
        }
        appContext.updateNotificationState({
          show: true,
          type: "error",
          message: "Error, please try after sometime.",
        });
        setLoading(false);
      });
  };

  const fetchTestimonials = (userId) => {
    axiosHttp
      .get(id == userName ? "testimonials" : `users/${userId}/testimonials`)
      .then((apiResponse) => {
        if (apiResponse.status === 200) {
          setTestimonials(apiResponse?.data?.data || []);
          setLoading(false);
        } else {
          appContext.updateNotificationState({
            show: true,
            type: "error",
            message: "Error, please try after sometime.",
          });
          setLoading(false);
        }
      })
      .catch((error) => {
        if (error.response.status === 429) {
          appContext.updateNotificationState({
            show: true,
            message: errorResponseMessage(error),
            type: "error",
          });
          authContext.logout();
        }
        if (error.response.status !== 422) {
          appContext.updateNotificationState({
            show: true,
            type: "error",
            message: errorResponseMessage(error),
          });
        }
        setLoading(false);
      });
  };

  const renderMedia = () => {
    if (userProfile?.isBlockedUser) {
      return (
        <img
          src={profile1}
          alt="Default Image"
          className="img-fluid postion-absolute banner-img"
        />
      );
    }
    if (userProfile?.bannerUrl === null) {
      return (
        <img
          src={profile1}
          alt="Default Image"
          className="img-fluid postion-absolute banner-img"
        />
      );
    }
    const fileExtension =
      userProfile?.bannerUrl &&
      userProfile?.bannerUrl.split(".").pop()?.toLowerCase();

    if (
      fileExtension === "png" ||
      fileExtension === "jpeg" ||
      fileExtension === "jpg" ||
      fileExtension === "gif"
    ) {
      return (
        <img
          src={userProfile.bannerUrl}
          alt="User Banner"
          className="img-fluid postion-absolute  banner-img cursor-pointer"
          onClick={() => {
            setShowImage(userProfile.bannerUrl);
          }}
        />
      );
    } else if (!fileExtension) {
      return (
        <img
          src={userProfile?.bannerUrl}
          alt="Default Image"
          className="img-fluid postion-absolute banner-img cursor-pointer"
          onClick={() => {
            setShowImage(userProfile.bannerUrl);
          }}
        />
      );
    } else {
      return (
        <VideoComponent
          userData={userProfile}
          isUserMenu={false}
          setShowImage={setShowImage}
        />
      );
    }
  };

  const renderMyMedia = () => {
    if (userProfile?.bannerUrl === null) {
      return (
        <img
          src={profile1}
          alt="Default Image"
          className="img-fluid postion-absolute banner-img"
        />
      );
    }
    const fileExtension =
      userProfile?.bannerUrl &&
      userProfile?.bannerUrl.split(".").pop()?.toLowerCase();

    if (
      fileExtension === "png" ||
      fileExtension === "jpeg" ||
      fileExtension === "jpg" ||
      fileExtension === "gif"
    ) {
      return (
        <img
          src={userProfile.bannerUrl}
          alt="User Banner"
          className="img-fluid postion-absolute banner-img"
        />
      );
    } else if (!fileExtension) {
      return (
        <img
          src={userProfile?.bannerUrl}
          alt="Default Image"
          className="img-fluid postion-absolute banner-img"
        />
      );
    } else {
      return (
        <VideoComponent
          userData={userProfile}
          isUserMenu={false}
          setShowImage={setShowImage}
        />
      );
    }
  };

  const handleRequest = async (status, userId) => {
    try {
      const followApi = await axiosHttp.post("follow", {
        userId: userId,
        status,
      });
      if (followApi.status === 201) {
        appContext.updateNotificationState({
          show: true,
          type: "success",
          message: `You gave follow request to ${userProfile?.fName} ${userProfile?.lName}`,
        });
        [(followerApiStatus.accept, followerApiStatus.cancel)].includes(status)
          ? dispatch(getFollowersList())
          : dispatch(getFollowerSuggestion());
        setUserProfile(null);
        getProfile();
        setIsOpen(false);
      }
    } catch (e) {
      if (e.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
        authContext.logout();
      }
      if (e.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
      }
      if (e.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
    }
  };

  const favouriteUser = async () => {
    try {
      const favourite = await axiosHttp.post(
        `favourite-users/${userProfile?.userId}`
      );
      if (favourite.status === 201) {
        let isFavouriteUser = userProfile?.isFavouriteUser ? false : true;
        if (isFavouriteUser) {
          appContext.updateNotificationState({
            show: true,
            type: "success",
            message: `This user has been marked as a favourite.`,
          });
        } else {
          appContext.updateNotificationState({
            show: true,
            type: "success",
            message: `This user has been removed from favourites.`,
          });
        }
        setUserProfile({ ...userProfile, isFavouriteUser: isFavouriteUser });
        setIsOpen(false);
      }
    } catch (error) {
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
    }
  };

  const newTabOpener = (url, media) => {
    const trimmedUrl = url.trim();
    let newUrl;

    if (media === "x") {
      newUrl = `https://x.com/${url}`;
    } else {
      if (trimmedUrl.startsWith("https://")) {
        newUrl = trimmedUrl;
      } else if (trimmedUrl.startsWith("http://")) {
        newUrl = trimmedUrl.replace("http://", "https://");
      } else {
        newUrl = `https://${trimmedUrl}`;
      }
    }

    const newWindow = window.open(newUrl, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };

  return loading ? (
    <Loader />
  ) : (
    <>
      <div className="card card-one-1">
        {isMyProfile ? renderMyMedia() : renderMedia()}
        {isMyProfile && (
          <img
            src={cameraIcon}
            className="img-fluid camera-icon cursor-pointer"
            data-toggle="modal"
            data-target="#photo"
            onClick={() =>
              appContext.updateModalType(
                "addBackgroundImage",
                userProfile?.bannerUrl
                  ? "Update background photo"
                  : "Add background photo"
              )
            }
          />
        )}
        <div className={`card-body ${isMyProfile ? "profile-wrapper" : null}`}>
          {isMyProfile ? (
            <div className="d-flex justify-content-between">
              <div className="sme-profile">
                <img
                  className={`img-profile rounded-circle profile-img ml-1 cursor-pointer ${
                    userProfile?.offerService ? "sme-service" : null
                  }`}
                  src={userProfile?.picUrl || undrawProfile}
                  onClick={() =>
                    appContext.updateModalType(
                      "addProfilePhoto",
                      userProfile?.picUrl
                        ? "Update Profile photo"
                        : "Add Profile photo"
                    )
                  }
                />
                {userProfile?.offerService && (
                  <div
                    className="sme-profile-icon"
                    style={{ zIndex: 11, right: "0" }}
                  >
                    SME
                  </div>
                )}
              </div>
              <span
                className="cursor-pointer"
                data-toggle="modal"
                data-target="#about"
                onClick={() =>
                  appContext.updateModalType(
                    "addBasicInfo",
                    "Basic Information"
                  )
                }
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.4303 3.0447C13.472 3.0772 14.8661 4.16054 14.8661 4.16054C15.3728 4.4622 15.7686 5.00137 15.9186 5.6397C16.0678 6.27137 15.9595 6.92303 15.612 7.47387C15.6097 7.47754 15.6074 7.48117 15.5993 7.49197L15.593 7.50031C15.5366 7.57465 15.2914 7.8847 14.0539 9.43519C14.0424 9.45551 14.0294 9.47454 14.0151 9.49303C13.9943 9.52029 13.9716 9.54535 13.9473 9.56817C13.8629 9.67445 13.7738 9.78612 13.68 9.90353L13.4901 10.1414C13.0982 10.6322 12.6333 11.2142 12.0818 11.9046L11.7988 12.2588C10.734 13.5914 9.37044 15.2977 7.62364 17.483C7.24114 17.9597 6.66781 18.2372 6.05198 18.2447L3.01948 18.283H3.01114C2.72198 18.283 2.47031 18.0847 2.40281 17.8022L1.72031 14.9097C1.57948 14.3105 1.71948 13.6922 2.10364 13.2122L9.95364 3.39387C9.95698 3.39054 9.95948 3.38637 9.96281 3.38304C10.8236 2.35387 12.3803 2.2022 13.4303 3.0447ZM9.07842 6.48917L3.07948 13.993C2.93698 14.1714 2.88448 14.4014 2.93698 14.6222L3.50448 17.0264L6.03698 16.9947C6.27781 16.9922 6.50031 16.8847 6.64781 16.7014C7.40738 15.751 8.36202 14.5566 9.34352 13.3283L9.69077 12.8938L10.0386 12.4585C10.9591 11.3066 11.8685 10.1684 12.6294 9.21572L9.07842 6.48917ZM10.9253 4.18054L9.85925 5.5125L13.4099 8.23827C14.0933 7.38225 14.5429 6.81845 14.5845 6.7647C14.7211 6.54304 14.7745 6.2297 14.7028 5.92804C14.6295 5.61887 14.437 5.35637 14.1595 5.18887C14.1003 5.14804 12.6961 4.05804 12.6528 4.02387C12.1245 3.60054 11.3536 3.67387 10.9253 4.18054Z"
                    fill="#575757"
                  />
                </svg>
              </span>
            </div>
          ) : (
            <div className="d-flex justify-content-between">
              <div className="sme-profile">
                <img
                  className={`img-profile rounded-circle z-circle profile-img ml-1 ${
                    userProfile?.offerService ? "sme-service" : null
                  }`}
                  src={
                    userProfile?.isBlockedUser
                      ? undrawProfile
                      : !userProfile?.isBlockedUser
                      ? userProfile?.picUrl
                      : undrawProfile
                  }
                  onClick={() => {
                    setShowImage(userProfile.picUrl);
                  }}
                />
                {userProfile?.offerService && (
                  <div
                    className="sme-profile-icon"
                    style={{ zIndex: 11, right: 0 }}
                  >
                    SME
                  </div>
                )}
              </div>
              <div className="col-1 col-sm-1 col-md-1" ref={containerRef}>
                {
                  <div className="dropdown book-edit" onClick={toggle}>
                    <span className="cursor-pointer">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="4"
                        height="17"
                        viewBox="0 0 4 17"
                        fill="none"
                      >
                        <circle cx="2" cy="2" r="2" fill="#000" />
                        <circle cx="2" cy="8" r="2" fill="#000" />
                        <circle cx="2" cy="15" r="2" fill="#000" />
                      </svg>
                    </span>
                  </div>
                }
                {isOpen && (
                  <div className="schedule-options report-options">
                    {userProfile?.hasOwnProperty("followingBackRequest") &&
                      (userProfile.followingBackRequest === null ||
                        userProfile.followingBackRequest === "C") &&
                      !userProfile?.isBlockedUser && (
                        <span
                          className="dropdown-item cursor-pointer mt-1"
                          onClick={() =>
                            handleRequest(
                              followerApiStatus.request,
                              userProfile?.userId
                            )
                          }
                        >
                          Follow
                        </span>
                      )}
                    <span
                      className="dropdown-item cursor-pointer mt-1 text-danger"
                      onClick={() =>
                        appContext.updateModalType(
                          "block",
                          "Block",
                          userProfile
                        )
                      }
                    >
                      {userProfile?.isBlockedUser ? "Unblock" : "Block"}
                    </span>
                  </div>
                )}
              </div>
            </div>
          )}
          {isMyProfile ? (
            <div className="row subscription-alignment">
              <div className="col-12 col-sm-12">
                <div className="mt-3">
                  <div>
                    <p className="profile-name mb-0">
                      {userProfile?.fName || ""} {userProfile?.lName || ""}
                    </p>
                    <p className="mt-1">
                      {userProfile?.experiences
                        ? truncateText(userProfile?.experiences, 60)
                        : ""}{" "}
                    </p>
                    <div className="d-flex w-100 justify-content-between">
                      <div>
                        <div className="social-icon">
                          <FontAwesomeIcon
                            icon={faLinkedin}
                            className={`linkedin-icon ${
                              userProfile?.linkedinProfile
                                ? "active-profile"
                                : ""
                            }`}
                            onClick={
                              userProfile?.linkedinProfile
                                ? () =>
                                    newTabOpener(userProfile?.linkedinProfile)
                                : null
                            }
                          />

                          <FontAwesomeIcon
                            icon={faFacebook}
                            className={`linkedin-icon ${
                              userProfile?.facebookProfile
                                ? "active-profile"
                                : ""
                            }`}
                            onClick={
                              userProfile?.facebookProfile
                                ? () =>
                                    newTabOpener(userProfile?.facebookProfile)
                                : null
                            }
                          />
                          <FontAwesomeIcon
                            icon={faInstagram}
                            className={`linkedin-icon ${
                              userProfile?.instagramProfile
                                ? "active-profile"
                                : ""
                            }`}
                            onClick={
                              userProfile?.instagramProfile
                                ? () =>
                                    newTabOpener(userProfile?.instagramProfile)
                                : null
                            }
                          />
                          <FontAwesomeIcon
                            icon={faYoutube}
                            className={`linkedin-icon ${
                              userProfile?.youtubeProfile
                                ? "active-profile"
                                : ""
                            }`}
                            onClick={
                              userProfile?.youtubeProfile
                                ? () =>
                                    newTabOpener(userProfile?.youtubeProfile)
                                : null
                            }
                          />
                          <FontAwesomeIcon
                            icon={faXTwitter}
                            className={`linkedin-icon ${
                              userProfile?.xProfile ? "active-profile" : ""
                            }`}
                            onClick={
                              userProfile?.xProfile
                                ? () => newTabOpener(userProfile?.xProfile, "x")
                                : null
                            }
                          />
                        </div>
                      </div>
                      <div>
                        <div className="social-icons">
                          <span
                            className="book-save-icon"
                            onClick={() => navigate("/favourite-users")}
                          >
                            <img src={heart} alt="heart" />
                          </span>

                          <span
                            className="book-save-icon"
                            onClick={() => navigate("/bookmark")}
                          >
                            <img src={save} alt="save" />
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  {showImage && showImage !== "" && (
                    <ImagePopup url={showImage} setShowImage={setShowImage} />
                  )}
                </div>
              </div>
              <div className="public-btn-settings">
                <button
                  className="btn btn-primary follow-btn search-follow-btn sub-btn"
                  onClick={() => navigate("/myspace/subscription")}
                >
                  My subscription
                </button>
                <button
                  className="btn btn-primary follow-btn search-follow-btn sub-btn"
                  onClick={() =>
                    appContext.updateModalType(
                      "public",
                      "Public Visibility Settings",
                      userProfile
                    )
                  }
                >
                  Edit Public Visibility
                </button>
              </div>
            </div>
          ) : (
            <>
              <div className="row mt-3 mb-2">
                <div className="col-md-7">
                  <p className="profile-name mb-0 ml-3">
                    {userProfile?.fName || ""} {userProfile?.lName || ""}
                  </p>
                </div>
              </div>
              <p className="ml-3">
                {userProfile?.experiences
                  ? truncateText(userProfile?.experiences, 60)
                  : ""}{" "}
              </p>
              <p className="ml-3">
                {userProfile?.followowersCount || 0} Followers
              </p>
              <div className="w-100 d-flex justify-content-between">
                <div className="social-icon ml-3">
                  <FontAwesomeIcon
                    icon={faLinkedin}
                    className={`linkedin-icon ${
                      userProfile?.linkedinProfile ? "active-profile" : ""
                    }`}
                    onClick={
                      userProfile?.linkedinProfile
                        ? () => newTabOpener(userProfile?.linkedinProfile)
                        : null
                    }
                  />

                  <FontAwesomeIcon
                    icon={faFacebook}
                    className={`linkedin-icon ${
                      userProfile?.facebookProfile ? "active-profile" : ""
                    }`}
                    onClick={
                      userProfile?.facebookProfile
                        ? () => newTabOpener(userProfile?.facebookProfile)
                        : null
                    }
                  />
                  <FontAwesomeIcon
                    icon={faInstagram}
                    className={`linkedin-icon ${
                      userProfile?.instagramProfile ? "active-profile" : ""
                    }`}
                    onClick={
                      userProfile?.instagramProfile
                        ? () => newTabOpener(userProfile?.instagramProfile)
                        : null
                    }
                  />
                  <FontAwesomeIcon
                    icon={faYoutube}
                    className={`linkedin-icon ${
                      userProfile?.youtubeProfile ? "active-profile" : ""
                    }`}
                    onClick={
                      userProfile?.youtubeProfile
                        ? () => newTabOpener(userProfile?.youtubeProfile)
                        : null
                    }
                  />
                  <FontAwesomeIcon
                    icon={faXTwitter}
                    className={`linkedin-icon ${
                      userProfile?.xProfile ? "active-profile" : ""
                    }`}
                    onClick={
                      userProfile?.xProfile
                        ? () => newTabOpener(userProfile?.xProfile, "x")
                        : null
                    }
                  />
                </div>
                <div className="social-icon mr-3">
                  <span
                    className={`book-save-icon ${
                      userProfile?.isFavouriteUser && "remove-fav-icon"
                    }`}
                    onClick={favouriteUser}
                  >
                    <img
                      src={
                        userProfile?.isFavouriteUser
                          ? removeFavourite
                          : addFavourite
                      }
                      alt="heart"
                    />
                  </span>
                </div>
              </div>
            </>
          )}
        </div>
        {!isMyProfile && showImage && showImage !== "" && (
          <ImagePopup url={showImage} setShowImage={setShowImage} />
        )}
        {isMyProfile && <ProfileView type={"edit"} testData={testimonials} />}
        {!isMyProfile && !userProfile?.isBlockedUser && (
          <div className="boxed">
            <div>
              <div className="tab-pane fade show active">
                <div className="tabbable">
                  <ul className="test-nav nav-tabs">
                    <li className="active">
                      <ProfileView
                        type="view"
                        viewUserData={userProfile}
                        testData={testimonials}
                      />
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default UserProfileView;
